require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/lib/draw2d/shape/icon/Expand.js"))